export default __webpack_public_path__ + "static/media/pg-3.5c1969cb.jpg";